module.exports = __webpack_public_path__ + "static/media/h-square.a54889ee.svg";